
function findCookie(name) {
    const nameEq = name + '=';
    const cookie = document.cookie.split(';').find(c => c.includes(nameEq));
    return cookie ? cookie.replace(nameEq, '').trim() : null;
}

function setCookie(name, value, expiresSeconds) {
    const date = new Date();
    date.setTime(date.getTime() + (expiresSeconds * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function deleteCookie(name) {
    setCookie(name, null, 0);
}

export {
    setCookie,
    findCookie,
    deleteCookie
};